import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["closePopover", "openItems", "showSubMenu"];
import React from 'react';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { AvatarPopoverMenu } from './AvatarPopoverMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export function AvatarPopover(props) {
  var closePopover = props.closePopover,
    _props$openItems = props.openItems,
    openItems = _props$openItems === void 0 ? [] : _props$openItems,
    showSubMenu = props.showSubMenu,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(Popover, _extends({}, others, {
    // PaperProps={{}}
    anchorOrigin: {
      horizontal: -16,
      vertical: 'top'
    },
    elevation: 3,
    marginThreshold: 0,
    onClose: closePopover,
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    "data-element": "Popover",
    "data-component": "AvatarPopover",
    "data-source-file": "AvatarPopover.tsx",
    children: /*#__PURE__*/_jsx(Stack, {
      direction: "row-reverse",
      sx: {
        maxHeight: 'calc(100vh - 100px)'
      },
      "data-element": "Stack",
      "data-source-file": "AvatarPopover.tsx",
      children: openItems.map(function (openItem, index) {
        var level = index + 1;
        return /*#__PURE__*/_jsx(AvatarPopoverMenu, {
          closePopover: closePopover,
          "data-testid": "".concat(openItem.key),
          level: level,
          navItem: openItem,
          showSubMenu: showSubMenu
        }, openItem.key);
      })
    })
  }));
}